import React, { Component } from "react";
import hospitalIcon from "../../../assets/images/Bitmap.png";
import dashboardIcon from "../../../assets/images/Dashboard.svg";
import tokenGeneratorIcon from "../../../assets/images/TokenGenerator.svg";
import operatorIcon from "../../../assets/images/Operator.svg";
import doctorIcon from "../../../assets/images/Doctor.svg";
import reportsIcon from "../../../assets/images/Reports.svg";
import profileIcon from "../../../assets/images/Oval.png";
import { Link } from "react-router-dom";

class NavBar extends Component {
  render() {
    return (
      <div className="navBar">
        <div className="row">
          <div className="col-2">
            <div className="hospitalicon">
              <img alt="" src={hospitalIcon} width="100px" height="50px" />
            </div>
          </div>
          {/* menu */}
          <div className="col-9 mt-2">
            <div className="row">
              <div className="col-1.5">
                <div className="row">
                  <Link to="/dashboard">
                    <img alt="" src={dashboardIcon} class="dashboardIcon" />
                    <span class="DashboardSpan">Dashboard</span>
                  </Link>
                </div>
              </div>
              <div class="navDivider" />

              <div className="col-1.5">
                <div className="row">
                  <Link to="/token-generator">
                    <img
                      alt=""
                      src={tokenGeneratorIcon}
                      class="tokenGeneratorIcon"
                    />
                    <span class="DashboardSpan Token-GeneratorSpan">
                      Token Generator
                    </span>
                  </Link>
                </div>
              </div>
              <div class="navDivider" />

              <div className="col-1.5">
                <div className="row">
                  <Link to="/biller">
                    <img alt="" src={tokenGeneratorIcon} class="billerIcon" />
                    <span class="DashboardSpan BillerSpan">Biller</span>
                  </Link>
                </div>
              </div>
              <div class="navDivider" />

              <div className="col-1.5">
                <div className="row">
                  <Link to="/operator">
                    <img alt="" src={operatorIcon} className="operatorIcon" />
                    <span class="DashboardSpan OperatorSpan">Operator</span>
                  </Link>
                </div>
              </div>
              <div class="navDivider" />

              <div className="col-1.5">
                <div className="row">
                  <Link to="/doctor">
                    <img alt="" src={doctorIcon} />
                    <span class="DashboardSpan DoctorSpan">Doctor</span>
                  </Link>
                </div>
              </div>
              <div class="navDivider" />

              <div className="col-1.5">
                <div className="row">
                  <Link to="/reports">
                    <img alt="" src={reportsIcon} className="reportsIcon" />
                    <span class="DashboardSpan ReportsSpan">Reports</span>
                  </Link>
                </div>
              </div>
              <div class="navDivider" />

              <div className="col-1.5">
                <div className="row">
                  <Link to="/settings">
                    <img alt="" src={reportsIcon} className="reportsIcon" />
                    <span class="DashboardSpan ReportsSpan">Settings</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-1 profile">
            <img alt="" src={profileIcon} width="50px" height="50px" />
          </div>
        </div>
      </div>
    );
  }
}
export default NavBar;
